/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `STD` - Standard
* `SIRIM` - Sirim
* `PERN` - Pern
* `SUPPLIER` - Supplier
 */
export type InspectionType = typeof InspectionType[keyof typeof InspectionType];


export const InspectionType = {
  STD: 'STD',
  SIRIM: 'SIRIM',
  PERN: 'PERN',
  SUPPLIER: 'SUPPLIER',
} as const;
